/**
 * Created by anatoly on 14.11.2024
 */

const ActiveCalendarTileComponent = cc.Node.extend({
    ctor: function (tile) {
        this._super();

        this.tile = tile;

        this.createTitleBg();
        this.createTitle();
        this.animateShowTitle();
    },

    isLast: function () {
        return this.tile.isLast;
    },

    animateShowTitle: function () {
        this.titleBg.setOpacity(0);
        this.titleBg.runAction(
            new cc.FadeIn(0.3).easing(cc.easeIn(2))
        );
    },

    createTitleBg: function () {
        const styles = cleverapps.styles.ActiveCalendarTileComponent;

        if (cleverapps.config.ui === "wooden") {
            this.titleBg = new cc.Node();
        } else if (bundles.prizecalendar.frames.title_bg) {
            this.titleBg = cleverapps.UI.createScale9Sprite(bundles.prizecalendar.frames.title_bg, cleverapps.UI.Scale9Rect.TwoPixelXY);
        } else if (this.tile.state === PrizeCalendarTile.STATE_WAITING) {
            this.titleBg = cleverapps.UI.createScale9Sprite(bundles.prizecalendar.frames.title_bg_locked, cleverapps.UI.Scale9Rect.TwoPixelXY);
        } else {
            this.titleBg = cleverapps.UI.createScale9Sprite(bundles.prizecalendar.frames.title_bg_unlocked, cleverapps.UI.Scale9Rect.TwoPixelXY);
        }

        this.titleBg.setCascadeOpacityEnabled(true);

        this.titleBg.setContentSize2(styles.titleBg);
        this.titleBg.setAlignment(styles.titleBg);

        this.addChild(this.titleBg);
    },

    createTitle: function () {
        const styles = cleverapps.styles.ActiveCalendarTileComponent;

        if (this.tile.state === PrizeCalendarTile.STATE_WAITING) {
            this.title = new cleverapps.CountDownView(
                this.tile.countDown,
                {
                    font: cleverapps.styles.FONTS.PRIZE_CALENDAR_TITLE,
                    showHours: false
                }
            );
            this.title.fitTo(styles.title.width, styles.title.height);

            if (connector.ads.isRewardedAvailable) {
                this.addAdIcon();
            } else {
                cleverapps.rewardedAdsManager.onRewardedRefresh(this.addAdIcon.bind(this), this);
            }
        } else if (!this.tile.price) {
            // eslint-disable-next-line no-restricted-syntax
            this.title = cleverapps.UI.generateTTFText(Messages.get("PrizeCalendarTile.Claim"), cleverapps.styles.FONTS.PRIZE_CALENDAR_TITLE);
            this.title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            this.title.setDimensions(styles.title.width, styles.title.height);
        } else {
            this.title = new TextWithIcon(`${this.tile.price}$$`, {
                font: cleverapps.styles.FONTS.PRIZE_CALENDAR_TITLE,
                width: styles.title.width,
                height: styles.title.height
            });
        }

        this.title.setCascadeOpacityEnabled(true);
        this.title.setAlignment(styles.title);

        this.titleBg.addChild(this.title);
    },

    addAdIcon: function () {
        if (!["heroes", "wooden"].includes(cleverapps.config.ui)) {
            return;
        }

        const icon = new cc.Sprite(bundles.buttons_inlined_icons.frames.ad_icon_png);
        icon.setAlignment(cleverapps.styles.ActiveCalendarTileComponent.adIcon);

        this.titleBg.addChild(icon);
        if (cleverapps.config.ui === "wooden") {
            icon.setRotation(25);
        }

        icon.setVisible(false);
        icon.runAction(StandartAnimations.showUp(icon, { flash: true }));
    },

    onReceiveTile: function (rewardList, callback) {
        if (["heroes", "wooden"].indexOf(cleverapps.config.ui) === -1) {
            this.afterReceiveTile(rewardList);
            callback();
        } else {
            this.bgReceiveAnimation(rewardList, callback);
        }
    },

    bgReceiveAnimation: function (rewardList, callback) {
        this.titleBg.runAction(new cc.FadeOut(0.3).easing(cc.easeOut(2)));

        const tileView = this.getParent();
        const bg = cleverapps.config.ui === "heroes" ? tileView.outerBg : tileView.innerBg;

        this.beforeReceiveAnimation(rewardList);

        bg.setAnimation(0, this.isLast() ? "receive_animation_last" : "receive_animation", false);
        bg.setCompleteListener(() => {
            this.afterReceiveTile(rewardList, callback);
        });
    },

    beforeReceiveAnimation: function (rewardList) {
        if (!["heroes", "wooden"].includes(cleverapps.config.ui)) {
            return;
        }

        const styles = cleverapps.styles.PrizeCalendarTileView.rewards;
        const tileView = this.getParent();

        const rewardIcon = this.rewardIcon = rewardList.rewards[0].getIcon();
        cleverapps.UI.fitToBox(rewardIcon, styles.fitToBox);

        tileView.addChild(rewardIcon, -1);
        rewardIcon.setAlignment(styles);
    },

    afterReceiveTile: function (rewardList, callback) {
        if (this.isLast()) {
            const window = cleverapps.focusManager.currentWindow();

            window.onChestAnimation(rewardList);
            return;
        }

        this.collect(rewardList, callback);
    },

    collect: function (rewardList, callback) {
        let reward = this.getParent().rewards;

        if (reward) {
            rewardList.collectRewardsAnimation(reward, {
                flyingAnimation: Reward.JUMP_COLLECT_ANIMATION,
                allAtOnce: true,
                small: false,
                beginScale: reward.content ? reward.content.scale : this.scale,
                callback
            });

            return;
        }

        if (!this.rewardIcon) {
            return;
        }

        reward = this.rewardIcon;

        const tileView = this.getParent();

        const scene = cleverapps.Scenes.GetRunningScene();
        const bg = tileView.innerBg || tileView.outerBg;

        const baseZOrder = bg.getLocalZOrder();
        const baseParent = bg.getParent();

        if (cleverapps.config.ui === "wooden") {
            bg.replaceParentSamePlace(scene);
            bg.setLocalZOrder(scene.movingNode.getLocalZOrder() + 1);
        }

        reward.replaceParentSamePlace(cleverapps.Scenes.GetMovingNode());
        reward.runAction(new cc.Sequence(
            cc.JumpAnimation(0.5, reward, cc.p(0, 200), 200),
            new cc.CallFunc(() => {
                if (cleverapps.config.ui === "wooden") {
                    bg.replaceParentSamePlace(baseParent);
                    bg.setLocalZOrder(baseZOrder);
                }

                rewardList.collectRewardsAnimation(reward, {
                    callback
                });
            })
        ));
    }
});

cleverapps.styles.ActiveCalendarTileComponent = {
    titleBg: {
        width: 145,
        height: 50,
        x: { align: "center" },
        y: { align: "top", dy: 15 }
    },

    title: {
        x: { align: "center" },
        y: { align: "center" },
        width: 140,
        height: 45
    }
};